export class CreateOAuthAppResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "oauthApp",
            "baseName": "oauthApp",
            "type": "OAuthApp",
            "format": ""
        },
        {
            "name": "clientSecret",
            "baseName": "clientSecret",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOAuthAppResponse.attributeTypeMap;
    }
    constructor() {
    }
}
